module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/assessment_achievements/1_ed4621b43ed3f9d296ffde393b027cf3.png";